import { useState, useEffect } from 'react';

interface LazyImageProps {
  src: string;
  alt: string;
  className?: string;
  skeletonClassName?: string;
}

/**
 * LazyImage component with loading skeleton
 * Provides better UX when loading images
 */
export const LazyImage = ({
  src,
  alt,
  className = '',
  skeletonClassName = '',
}: LazyImageProps) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  // Reset imageLoaded when src changes
  useEffect(() => {
    setImageLoaded(false);
  }, [src]);

  return (
    <div className="relative">
      {/* Skeleton loading placeholder */}
      {!imageLoaded && (
        <div
          className={`absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse ${skeletonClassName}`}
        />
      )}

      {/* Image with lazy loading */}
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className={`transition-opacity duration-300 ${
          imageLoaded ? 'opacity-100' : 'opacity-0'
        } ${className}`}
        onLoad={() => setImageLoaded(true)}
        onError={() => setImageLoaded(true)}
      />
    </div>
  );
};
